import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { featureEnabled } from 'helpers/ToggleBot';
import MaintenanceProjectsTable from '../components/MaintenanceProjectsTable';
import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';
import {
  postProject,
  fetchAllProjects,
  fetchProjectStats,
  fetchFilteredProjects,
} from '../store/actions';

class MaintenanceProjects extends Component {
  componentDidMount = () => {
    this.fetchAllProjectsAndStats();
    this.props.getProperties({ for_multiselect: true, show_cities: true });
    if (!featureEnabled('ui.maintenance.new_tickets_ui')) {
      browserHistory.push('/companies/dashboard');
    }
  };

  fetchAllProjectsAndStats = () => {
    this.props.fetchAllProjects();
    this.props.fetchProjectStats();
  };

  openProjectByID = rowData => {
    const projectID = rowData.original_id || rowData.id;
    browserHistory.push(`/companies/maintenance/projects/${projectID}`);
  };

  fetchUnitsOfProperty = async property_id => {
    // Clear units and leases on reselection
    await this.props.showUnits([]);
    return this.props.getUnits(property_id, { for_multiselect: true });
  };

  render() {
    return (
      <MaintenanceProjectsTable
        data={this.props.data}
        fetchFilteredProjects={this.props.fetchFilteredProjects}
        fetchAllProjects={this.props.fetchAllProjects}
        fetchAllProjectsAndStats={this.fetchAllProjectsAndStats}
        fetchProjectStats={this.props.fetchProjectStats}
        isLoading={this.props.isFetching}
        properties={this.props.properties}
        postProject={this.props.postProject}
        units={this.props.units}
        fetchUnitsOfProperty={this.fetchUnitsOfProperty}
        onRowClick={this.openProjectByID}
        projectCounts={this.props.projectCounts}
        searchTotalResultsCount={this.props.filteredProjectCount}
      />
    );
  }
}

const mapStateToProps = store => ({
  properties: store.landlordProperties.properties,
  units: store.landlordProperties.units,
  data: store.landlord.maintenance.projects.data,
  filteredProjectCount: store.landlord.maintenance.projects.filteredProjectCount,
  projectCounts: store.landlord.maintenance.projects.projectCounts,
  isFetching: store.landlord.maintenance.projects.isFetching,
});

const actionCreators = {
  fetchAllProjects,
  fetchProjectStats,
  fetchFilteredProjects,
  getProperties,
  getUnits,
  showUnits,
  postProject,
};

export default connect(mapStateToProps, actionCreators)(MaintenanceProjects);
